<template>
    <Breadcrumbs main="Ecommerce" title="Wishlist" />
    <div class="container-fluid">
        <div class="row">

            <Card9 colClass="col-sm-12" cardhaderClass="title-header" title="Wishlist">
                <div class="row g-sm-4 g-3">
                    <wishList />
                </div>
            </Card9>

        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))
const wishList = defineAsyncComponent(() => import("@/components/theme/ecommerce/whishlist/wishList.vue"))
</script>